module.exports = __webpack_public_path__ + "img/hy-logo2.bd982023.png";